module.exports = __webpack_public_path__ + "static/media/pattern-main.691083b6.svg";